import { Link } from "react-router-dom";
import { LOGO_URL } from "@/data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-zinc-900/10 bg-[#EDEFF2]">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-4">
          <img src={LOGO_URL} alt="AIS" className="h-16 w-16 object-cover" />
          <span className="font-heading text-2xl font-bold text-zinc-900 sm:text-3xl">Augmented Intelligence Systems</span>
        </div>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-500">
          Enterprise AI you can prove. Ten products, six modular engines, one blockchain trust layer — built for any business where being wrong isn't an option.
        </p>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">SOC 2 · HIPAA-READY · FEDRAMP IN-PROCESS</p>
      </div>
      <div>
        <p className="label-mono mb-4">Navigate</p>
        <div className="flex flex-col gap-3 text-sm text-zinc-600">
          <Link to="/" className="transition-colors hover:text-cyan-600">Home</Link>
          <Link to="/products" className="transition-colors hover:text-cyan-600">Products</Link>
          <Link to="/platform" className="transition-colors hover:text-cyan-600">Platform</Link>
          <Link to="/managed-services" data-testid="footer-ms-link" className="transition-colors hover:text-cyan-600">Managed AI Services</Link>
          <Link to="/assessment" data-testid="footer-assessment-link" className="transition-colors hover:text-cyan-600">Free AI Operations Assessment</Link>
          <Link to="/contact" className="transition-colors hover:text-cyan-600">Contact</Link>
        </div>
      </div>
      <div>
        <p className="label-mono mb-4">Company</p>
        <div className="flex flex-col gap-3 text-sm text-zinc-600">
          <span>admin@aintelligence.systems</span>
          <span>Atlanta / Remote</span>
          <a
            data-testid="footer-linkedin-link"
            href="https://www.linkedin.com/company/augmented-intelligence-systems/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-cyan-600"
          >
            LinkedIn ↗
          </a>
          <a
            data-testid="footer-founder-blog-link"
            href="https://www.aboveaveragemindset.com"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-cyan-600"
          >
            Founder's Blog ↗
          </a>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-cyan-600">Admin</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-zinc-900/5 px-6 py-6">
      <p className="mx-auto max-w-7xl font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
        © 2026 Augmented Intelligence Systems, Inc. — All decisions verifiable. Built for every business.
      </p>
    </div>
  </footer>
);

export default Footer;
